import { Component, Input } from '@angular/core';
import { DynamicFormGroup } from '@anecdotes/dynamic-form';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'dynamic-form-outlet',
  template: '',
  standalone: false,
})
export class DynamicFormOutletMockComponent {
  @Input()
  dynamicFormGroup: DynamicFormGroup<any>;
}
